<ng-container *ngIf="filteredDeceased.length > 0; else noDeceased">
    <ng-container *ngFor="let section of patientStatusOptions">
        <div class="list-header expandable" (click)="toggleExpanded(section.id)">
            {{ section.name }}
            <mat-icon aria-hidden="false" aria-label="Expand/Collapse">
                {{ expandedSection === section.id ? 'expand_less' : 'expand_more' }}
            </mat-icon>
        </div>
        <div *ngIf="expandedSection === section.id">
            <mat-list>
                <mat-list-item *ngFor="let patient of $any(section.patients | slice:0:shown)" class="auto-height">
                    <div class="list-item stack-mobile">
                        <div class="details">
                            <div matLine class="primary-text">
                                <b>{{ patient.surname }}, {{ patient.name }}</b>
                            </div>
                            <div matLine class="secondary-text">
                                <span>{{ patient.diagnosis || patient.email || '' }}</span>
                            </div>
                            <div matLine class="secondary-text" *ngIf="patient.dateOfDeath">
                                <span>Date of death: {{ patient.dateOfDeath | date }}</span>
                            </div>
                        </div>
                        <div class="action-icons">
                            <button mat-icon-button matTooltip="View the patient file"
                                (click)="navigateToPatientFile($event, patient.id)">
                                <mat-icon>visibility</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-list-item>
                <div *ngIf="shown < section.patients.length" (appRenderMore)="shown = shown + renderBatch"></div>
            </mat-list>
        </div>
    </ng-container>
</ng-container>
<div class="mobile-spacer"></div>

<ng-template #noDeceased>
    <p class="no-records-message">No deceased patients recorded.</p>
</ng-template>
